/**
 * 登录门禁与待办任务续做工具
 * 需求：调用需要身份标识的接口（listBjsp / expiring-list / mailingDetail/list / CSV导出 / 备注 / 批文库）时，
 * 未登录则跳转登录页，登录完成后自动继续原来的任务（无需重新填参、无需再次点击）
 */

// 判断是否已登录（本地有 token 即视为已登录，后端 401 会再次引导登录）
export const isLoggedIn = () => {
  const token = localStorage.getItem('token')
  return !!token
}

// 获取当前登录用户手机号（全局唯一身份标识）
export const getPhone = () => {
  try {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      const u = JSON.parse(userInfo)
      return u.phone || u.wxPhone || ''
    }
  } catch (e) {
    // ignore
  }
  return ''
}

// 判断当前用户是否管理员（t_user.role=admin）
export const isAdminUser = () => {
  try {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      const u = JSON.parse(userInfo)
      return u.role === 'admin'
    }
  } catch (e) {
    // ignore
  }
  return false
}

// 待办任务存取（sessionStorage，登录后消费）
const PENDING_KEY = 'pendingAction'

export const savePendingAction = (action) => {
  sessionStorage.setItem(PENDING_KEY, JSON.stringify(action))
}

export const getPendingAction = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const clearPendingAction = () => {
  sessionStorage.removeItem(PENDING_KEY)
}

/**
 * 登录门禁：未登录则保存待办任务并跳转登录页，返回 false；已登录返回 true
 * @param {object} router vue-router 实例
 * @param {string} redirectTo 登录成功后返回的路径
 * @param {object|null} pendingAction 待办任务（登录后自动继续）
 */
export const requireLogin = (router, redirectTo, pendingAction = null) => {
  if (isLoggedIn()) {
    return true
  }
  if (pendingAction) {
    pendingAction.redirectTo = redirectTo
    savePendingAction(pendingAction)
  }
  // 小程序环境（web-view 内）直接跳转原生登录页
  const isWxMini = /miniProgram/i.test(navigator.userAgent)
  if (isWxMini) {
    if (window.wx && window.wx.miniProgram) {
      window.wx.miniProgram.postMessage({ action: 'login' })
      window.wx.miniProgram.navigateTo({ url: '/pages/login/login' })
    }
    return false
  }
  router.push({
    name: 'login',
    query: { redirectTo }
  })
  return false
}

/**
 * 判断错误是否为未登录（401）
 */
export const isUnauthorized = (error) => {
  return error && error.response && error.response.status === 401
}

/**
 * 通用 401 处理：跳转登录页并带待办任务，返回 true 表示已处理
 */
export const handleUnauthorized = (router, error, pendingAction = null) => {
  if (!isUnauthorized(error)) {
    return false
  }
  const current = router.currentRoute.value.fullPath
  requireLogin(router, current, pendingAction)
  return true
}

/**
 * 带认证的 axios 请求（登录后续做任务时使用）
 */
export const authedRequest = (axios, config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers = Object.assign({}, config.headers, {
      Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`
    })
  }
  return axios(config)
}
